

import React, { useEffect } from "react";
import { FlexGrid, TextField, SelectProps, TextFieldProps, } from '@albo-ui/core'
import { ItemType } from "../../../util/hooks/useCatalog";



export type InputGroupProps = {
    selectProps: SelectProps<ItemType>,
    inputProps: TextFieldProps
}

export const InputGroup = ({ selectProps, inputProps }: InputGroupProps) => {


    const handleChange = (e) => {
        const ixValue = e.target.value;
        selectProps.onInput(selectProps.items[ixValue])
    }
    useEffect(() => {
        selectProps.onInput(selectProps.items[0])
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return <FlexGrid container direction="row" flex={1}>

        <select style={{ width: "33%", paddingRight: "20px", borderRight: "8px solid transparent", borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
            onChange={handleChange}
        >
            {selectProps.items.map((item, index) => {
                return <option key={`${index}`} value={index}>
                    {item.name}
                </option>
            })
            }
        </select>

        <TextField
            className="input-group"
            {...inputProps}
            containerStyle={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
            style={{ flex: "4", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
        />
    </FlexGrid>
}